import React from 'react';
import { QuizAnswer } from './types';

interface QuizQuestionProps {
  questionNumber: number;
  onAnswer: (answer: QuizAnswer) => void;
}

const questions = [
  {
    question: "How do you take your coffee?",
    options: [
      { text: "🖤 Black. Because life's complicated enough.", weights: { dark: 2, light: 1 } },
      { text: "🥛 With a splash of milk or cream.", weights: { medium: 2 } },
      { text: "🍦 Cream and sugar. Basically dessert.", weights: { medium: 1, dark: 1 } },
      { text: "❄️ Iced. Yes, even in January.", weights: { medium: 2 } },
      { text: "☕ Espresso drinks. I enjoy tiny cups that cost $6.", weights: { espresso: 3 } }
    ]
  },
  {
    question: "What's your flavor vibe?",
    options: [
      { text: "🌸 Bright & fruity – like a garden party, minus the mosquitoes.", weights: { light: 3 } },
      { text: "🍫 Chocolatey & nutty – cozy and familiar.", weights: { medium: 3 } },
      { text: "🌱 Smoky & earthy – I like my coffee with a little grit.", weights: { dark: 3 } },
      { text: "🚀 Rich & intense – caffeine should feel like a punch in the face.", weights: { espresso: 2, dark: 1 } },
      { text: "🤷 I'm not sure – let's just wing it together.", weights: { medium: 2 } }
    ]
  },
  {
    question: "You walk into a coffee shop. Two brews call your name. Which one wins?",
    options: [
      { text: "🌞 Light & zippy – almost tea-like.", weights: { light: 3 } },
      { text: "🍯 Sweet & balanced – easy to love, hard to put down.", weights: { medium: 3 } },
      { text: "🌋 Dark & bold – subtlety is overrated.", weights: { dark: 3 } },
      { text: "🔥 Thick & rich – basically espresso's big personality cousin.", weights: { espresso: 3 } }
    ]
  },
  {
    question: "How bold do you like it? (Your coffee. Stay with me.)",
    options: [
      { text: "☁️ Smooth & mild – coffee as a gentle hug.", weights: { light: 3 } },
      { text: "🌿 Balanced – not too soft, not too strong. Goldilocks-approved.", weights: { medium: 3 } },
      { text: "⚡ Rich & punchy – I want my coffee to stare back at me.", weights: { dark: 2, espresso: 1 } }
    ]
  },
  {
    question: "How do you brew at home?",
    options: [
      { text: "🤖 Drip machine – push button. Receive coffee.", weights: { medium: 1, dark: 1 } },
      { text: "🎨 Pour-over – I enjoy feeling like a coffee scientist.", weights: { light: 3 } },
      { text: "💪 French press or AeroPress – a little effort for big flavor.", weights: { medium: 1, dark: 1 } },
      { text: "🚀 Espresso machine – because I'm worth it.", weights: { espresso: 3 } },
      { text: "🧊 Cold brew – patience is a virtue… I guess.", weights: { medium: 1, dark: 1 } },
      { text: "🤷 Whatever's easiest – caffeine is caffeine.", weights: { medium: 2 } }
    ]
  }
];

export default function QuizQuestion({ questionNumber, onAnswer }: QuizQuestionProps) {
  const question = questions[questionNumber];

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h3 className="text-2xl font-bold text-white mb-4">
          {question.question}
        </h3>
      </div>

      <div className="space-y-4">
        {question.options.map((option, index) => (
          <button
            key={index}
            onClick={() => onAnswer({ questionNumber, optionIndex: index, weights: option.weights })}
            className="w-full p-4 text-left bg-white/5 hover:bg-white/10 rounded-lg border border-white/10 hover:border-[#fda36b]/30 transition-all duration-300 group"
          >
            <span className="text-white group-hover:text-[#fda36b] transition-colors">
              {option.text}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}